import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "radio-health-options my-4" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "value", "checked", "disabled", "onChange"]
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "fw-bold" }

import { ref, computed, onMounted, watch } from "vue";
    import HelpText from "@/guiide/ts/helpText";
    import Help from "@/guiide/components/common/Help.vue";
    import HealthState from "@/guiide/ts/healthState";
    import { useStore } from "vuex";
    import { app } from "@/guiide/ts/app";
    import { getAgeAtRetirement } from "@/guiide/ts/utilities";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'HealthState',
  emits: ['complete'],
  setup(__props, { emit: __emit }) {

    const store = useStore();
    const selectedHealthState = ref(store.state.retiree?.health);
    const disableInputs = ref(false);

    const emit = __emit;

    onMounted(async () => {
        if (store.state.retiree?.health != null) {
            emit("complete");
        }
    });

    watch(
        () => store.state.retiree,
        (newRetireeValue) => {
            selectedHealthState.value = newRetireeValue?.health;

            if (newRetireeValue?.health != null) {
                emit("complete");
            }
        },
        { immediate: true }
    );

    const displayLifeExpectancyText = computed<boolean>(() => store.state.retiree?.lifeExpectancy != null && store.state.retiree?.lifeExpectancy != 0);

    const lifeExpectancy = computed<number>(() => store.state.retiree?.lifeExpectancy ?? 0);

    const ageAtDeath = computed<number>(() => {
        const ageAtRetirement = getAgeAtRetirement();
        return ageAtRetirement == null ? 0 : ageAtRetirement + lifeExpectancy.value;
    });

    function getHelpTitle(healthState: HealthState) {
        switch (healthState) {
            case HealthState.PreferNotToSay:
                return "Rather not say";
            case HealthState.Perfect:
                return "Perfect health";
            case HealthState.Minor:
                return "Minor health issues";
            case HealthState.Moderate:
                return "Moderate health issues";
            case HealthState.Major:
                return "Major health issues";
        }
    }

    function getHelpText(healthState: HealthState) {
        switch (healthState) {
            case HealthState.PreferNotToSay:
                return HelpText.healthStateRatherNotSay();
            case HealthState.Perfect:
                return HelpText.healthStatePerfect();
            case HealthState.Minor:
                return HelpText.healthStateMinor();
            case HealthState.Moderate:
                return HelpText.healthStateModerate();
            case HealthState.Major:
                return HelpText.healthStateMajor();
        }
    }

    async function changeHealthStatus(healthState: HealthState) {
        disableInputs.value = true;
        selectedHealthState.value = healthState;
        await app.updateHealthState(healthState);
        disableInputs.value = false;
    }

    function createHealthOption(healthState: HealthState, text: string) {
        return { healthState, text };
    }

    const healthOptions = [
        createHealthOption(HealthState.PreferNotToSay, "I'd rather not say"),
        createHealthOption(HealthState.Perfect, "I am in perfect health"),
        createHealthOption(HealthState.Minor, "I have some minor health issues"),
        createHealthOption(HealthState.Moderate, "I have some moderate health issues"),
        createHealthOption(HealthState.Major, "I have some major health issues"),
    ];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("p", {
      id: "healthQuestion",
      class: "mt-2"
    }, " If you are happy to answer the health question below, we will adjust your life expectancy to allow for your health. If not, we will use average life expectancy. ", -1)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(healthOptions, (healthOption, index) => {
        return _createElementVNode("div", {
          key: index,
          class: "my-3"
        }, [
          _createElementVNode("label", {
            for: `radio-health-${index}`
          }, [
            _createElementVNode("input", {
              class: "form-check-input",
              type: "radio",
              id: `radio-health-${index}`,
              value: healthOption.healthState,
              checked: healthOption.healthState == selectedHealthState.value,
              name: "healthStatus",
              disabled: disableInputs.value,
              onChange: ($event: any) => (changeHealthStatus(healthOption.healthState))
            }, null, 40, _hoisted_3),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "custom-radio" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(healthOption.text) + " ", 1),
            _createVNode(Help, {
              title: getHelpTitle(healthOption.healthState),
              text: getHelpText(healthOption.healthState),
              isWide: true
            }, null, 8, ["title", "text"])
          ], 8, _hoisted_2)
        ])
      }), 64))
    ]),
    (displayLifeExpectancyText.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", _hoisted_4, [
            _cache[1] || (_cache[1] = _createTextVNode(" Based on your answer above, you may be expected to live on average to around ")),
            _createElementVNode("span", _hoisted_5, _toDisplayString(ageAtDeath.value), 1),
            _cache[2] || (_cache[2] = _createTextVNode(". "))
          ]),
          _createElementVNode("p", _hoisted_6, [
            _cache[3] || (_cache[3] = _createTextVNode(" This means you need a plan which pays you an income for at least ")),
            _createElementVNode("span", _hoisted_7, _toDisplayString(lifeExpectancy.value), 1),
            _cache[4] || (_cache[4] = _createTextVNode(" years, if you retire when planned. "))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})